import ontarioHallImg from "@/assets/events/ontario-2025/ontario-2025-conference-hall.webp";
import ontarioTankHallImg from "@/assets/events/ontario-2025/ontario-2025-photo-3.webp";
import ontarioBiofilterImg from "@/assets/events/ontario-2025/ontario-2025-photo-4.webp";
import ontarioInspectImg from "@/assets/events/ontario-2025/ontario-2025-photo-6.webp";
import ontarioGreenwaterImg from "@/assets/events/ontario-2025/ontario-2025-photo-8.webp";
import ontarioRackImg from "@/assets/events/ontario-2025/ontario-2025-photo-1.webp";
import ontarioClip1 from "@/assets/events/ontario-2025/ontario-2025-clip-1.mp4";
import ontarioClip1Poster from "@/assets/events/ontario-2025/ontario-2025-clip-1-poster.webp";
import ontarioClip2 from "@/assets/events/ontario-2025/ontario-2025-clip-2.mp4";
import ontarioClip2Poster from "@/assets/events/ontario-2025/ontario-2025-clip-2-poster.webp";
import ontarioClip3 from "@/assets/events/ontario-2025/ontario-2025-clip-3.mp4";
import ontarioClip3Poster from "@/assets/events/ontario-2025/ontario-2025-clip-3-poster.webp";
import bisfeVenueImg from "@/assets/events/bisfe-2024/bisfe-2024-bexco-exterior.webp";
import bisfeVisit1Img from "@/assets/events/bisfe-2024/bisfe-2024-vars-visit-1.webp";
import bisfeVisit2Img from "@/assets/events/bisfe-2024/bisfe-2024-vars-visit-2.webp";
import bisfeExhibitorImg from "@/assets/events/bisfe-2024/optimized/bisfe-2024-exhibitor-1024.webp";
import bisfeProfileImg from "@/assets/events/bisfe-2024/optimized/bisfe-2024-company-profile-1024.webp";
import bisfeHarvestingImg from "@/assets/events/bisfe-2024/optimized/bisfe-2024-artemia-harvesting-1024.webp";
import bisfeReviveImg from "@/assets/events/bisfe-2024/optimized/bisfe-2024-revive-artemia-1024.webp";

export interface EventPhoto {
  src: string;
  captionKey: string;
  /** The venue image is already the BISFE article hero, so do not repeat it there. */
  articleGallery?: boolean;
}

export interface EventMedia {
  photos: EventPhoto[];
  videos: { src: string; poster: string; captionKey: string }[];
}

/**
 * First-party event media, keyed by TradeEvent id. BISFE's four square cards
 * were supplied by VARS to the organizer and published in its 2024 exhibitor
 * profile; docs/project/evidence/image-credits.md records the source URLs.
 */
export const EVENT_MEDIA: Record<string, EventMedia> = {
  bisfe: {
    photos: [
      {
        src: bisfeVenueImg,
        captionKey: "events.bisfe.media.0",
        articleGallery: false,
      },
      { src: bisfeExhibitorImg, captionKey: "events.bisfe.media.1" },
      { src: bisfeProfileImg, captionKey: "events.bisfe.media.2" },
      { src: bisfeHarvestingImg, captionKey: "events.bisfe.media.3" },
      { src: bisfeReviveImg, captionKey: "events.bisfe.media.4" },
      { src: bisfeVisit1Img, captionKey: "events.bisfe.media.5" },
      { src: bisfeVisit2Img, captionKey: "events.bisfe.media.6" },
    ],
    videos: [],
  },
  "ontario-aquaculture-2025": {
    photos: [
      { src: ontarioHallImg, captionKey: "events.ontario-aquaculture-2025.media.0" },
      { src: ontarioTankHallImg, captionKey: "events.ontario-aquaculture-2025.media.1" },
      { src: ontarioBiofilterImg, captionKey: "events.ontario-aquaculture-2025.media.2" },
      { src: ontarioInspectImg, captionKey: "events.ontario-aquaculture-2025.media.3" },
      { src: ontarioGreenwaterImg, captionKey: "events.ontario-aquaculture-2025.media.4" },
      { src: ontarioRackImg, captionKey: "events.ontario-aquaculture-2025.media.5" },
    ],
    videos: [
      {
        src: ontarioClip1,
        poster: ontarioClip1Poster,
        captionKey: "events.ontario-aquaculture-2025.media.6",
      },
      {
        src: ontarioClip2,
        poster: ontarioClip2Poster,
        captionKey: "events.ontario-aquaculture-2025.media.7",
      },
      {
        src: ontarioClip3,
        poster: ontarioClip3Poster,
        captionKey: "events.ontario-aquaculture-2025.media.8",
      },
    ],
  },
};
